import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { PublicHttpClientService } from "./http-client.service";

@Injectable()
export class PublicEarlySettlementsService {
  constructor(private publicHttp: PublicHttpClientService) {}

  public getEarlySettlement(termination_quote_id): Observable<any[]> {
    return this.publicHttp
      .get("/api/early_settlement/" + termination_quote_id)
      .pipe(tap((_) => console.log("PublicEarlySettlementsService.getEarlySettlement: Ok.")));
  }
}
